class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.querySelector('.mega-menu__content ul li a').addEventListener('click', this.megaMenuItemClicked.bind(this));

    this.megaMenuInit();
  }

  megaMenuInit() {
    this.megaMenuImageMaxWidth = 270;

    this.megaMenu = this.querySelector('.mega-menu__content');
    // this.megaMenu = document.getElementById('MegaMenu-Content-1');
    this.megaMenu.classList.add('mega-menu-with-products');

    this.megaMenuList = this.megaMenu.querySelector('.mega-menu__list');
    this.megaMenuList.classList.add('mega-menu__list--condensed');

    this.megaMenuProducts = document.createElement('div');
    this.megaMenuProducts.classList.add('mega-menu-products', 'twbs');
    this.megaMenu.appendChild(this.megaMenuProducts);

    this.isAusMarket = document.body.dataset.bchMarket.toUpperCase() === 'AU';
    this.ausMarketHandleSuffix = '-au';


    // this.megaMenuList.forEach(megaMenuList => {});

    const menuLinks = this.megaMenuList.querySelectorAll(':scope > li > a.mega-menu__link');
    menuLinks.forEach(link => {
      let href = link.getAttribute('href');
      if (!this.isAusMarket) {
        href = href.replace(this.ausMarketHandleSuffix, '');
      }

      let isItemList = false;
      const itemList = link.parentElement.querySelector('ul[role="list"]');
      if (!!itemList) {
        isItemList = true;
      }
      let showViewCollectionButton = isItemList ? false : true; // Collection Metafield "is_fake_collection"

      let dataParam = ' data-products="' + href + '/products.json"';
      if (isItemList) {
        const items = [];
        itemList.querySelectorAll('li').forEach((item) => {
          const item_handle = (new URL(item.querySelector('.mega-menu__link').href)).pathname;
          items.push(item_handle + '.json');
        });
        itemList.remove();
        dataParam = " data-items='" + JSON.stringify(items) + "'";
      }

      const template = document.createElement('template');
      template.innerHTML = `
      <div id="${link.id + '-products'}" class="product-list"${dataParam}>
        <div class="mb-4 d-flex align-items-center">
          <h2 class="h3 m-0 d-inline-block text-white">${link.textContent}</h2>
          ${showViewCollectionButton ? `<a class="btn btn-primary d-inline-block ms-3" href="${href}">View Collection</a>` : ''}
        </div>
        <div class="row"></div>
      </div>
      `;
      this.megaMenuProducts.appendChild(template.content.cloneNode(true));

      link.addEventListener('click', this.megaMenuItemClicked.bind(this));
    });

    menuLinks[0].click(); // Preload First Item

    window.addEventListener('load', () => {
      [...this.megaMenuProducts.querySelectorAll('.product-list')].slice(1).forEach((product_list) => {
        this.megaMenuLoadData(product_list);
      });
    });
  }
  megaMenuLoadData(product_list) {
    if (!!product_list.dataset.items) {
      this.megaMenuLoadItems(product_list, JSON.parse(product_list.dataset.items));
    } else if (!!product_list.dataset.products) {
      this.megaMenuLoadProducts(product_list, product_list.dataset.products);
    }
  }

  megaMenuItemClicked(e) {
    e.preventDefault();

    const product_list = document.getElementById(e.target.id + '-products');

    this.megaMenuLoadData(product_list);

    this.megaMenu.querySelectorAll('.mega-menu__link').forEach(_link => {
      _link.classList.remove('mega-menu__link--active');
    })
    e.target.classList.add('mega-menu__link--active');

    this.megaMenuProducts.querySelectorAll('.product-list').forEach(_product_list => {
      _product_list.classList.remove('active');
    })
    product_list.classList.add('active');
  }

  megaMenuLoadItems(products_el, json_urls) {
    if (!json_urls) {
      return;
    }
    const products_row = products_el.querySelector('.row');

    const requests = [];
    json_urls.forEach(json_url => {

      try {
        const request = fetch(json_url).then(function(response) {
          if (response.ok) {
            return response.json();
          } else {
            document.getElementById('menu-drawer').querySelectorAll('a[href="' + json_url.replace('.json', '') + '"]').forEach(_link => {
              _link.remove();
            })
            return null;
          }
        });
        // const request = fetch(json_url).then(response => response.json());
        if (request) {
          requests.push(request);
        }
      } catch (error) {}
    });

    Promise.all(requests)
      .then(([...datas]) => {
        datas.forEach(data => {
          if (!data) return;

          const isCollection = !!data.collection;
          const item = isCollection ? data.collection : (data.product ? data.product : false);
          const item_url = '/' + (isCollection ? 'collections' : 'products') + '/' + item.handle;

          let item_image_index = 0;
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has('megamenu_second_image')) {
            item_image_index = 1;
          }
          let item_image = isCollection ? item.image.src : item.images[item_image_index].src;

          item_image = item_image.replace('collections/Blue-Light-Blocking-Glasses.jpg', 'files/collection_list_img_glasses_blb.png');

          if (!isCollection) {
            if (item.tags.includes('magamenu-hidden') || item.tags.includes('hidden-in-productlist')) {
              return;
            }
          }

          if (item) {
            const template = document.createElement('template');
            template.innerHTML = `
            <div class="col">
              <div class="mega-menu-card">
                <div class="image">
                  <img src="${item_image}&width=${this.megaMenuImageMaxWidth}" alt="${item.title}" loading="lazy" />
                </div>
                <div class="content">
                  <strong><a href="${item_url}">${item.title}</a></strong>
                </div>
              </div>
            </div>
            `;
            products_row.appendChild(template.content.cloneNode(true));
          }
        });
      })
      .catch(error => {
        console.error(error);
      });

    products_el.dataset.items = '';
  }
  megaMenuLoadProducts(products_el, json_url) {
    if (!json_url) {
      return;
    }
    const products_row = products_el.querySelector('.row');
    fetch(json_url)
      .then((response) => response.json())
      .then((data) => {
        data.products.forEach((product) => {
          if (product.tags.includes('magamenu-hidden') || product.tags.includes('hidden-in-productlist')) {
            return;
          }
          const product_url = '/products/' + product.handle;

          let item_image_index = 0;
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has('megamenu_second_image')) {
            item_image_index = 1;
          }
          const product_image = product.images[item_image_index].src;
          const template = document.createElement('template');
          template.innerHTML = `
          <div class="col">
            <div class="mega-menu-card">
              <div class="content">
                <strong><a href="${product_url}">${product.title}</a></strong>
              </div>
            </div>
          </div>
          `;
          // template.innerHTML = `
          // <div class="col">
          //   <div class="mega-menu-card">
          //     <div class="image">
          //       <img src="${product_image}&width=${this.megaMenuImageMaxWidth}" alt="${product.title}" loading="lazy" />
          //     </div>
          //     <div class="content">
          //       <strong><a href="${product_url}">${product.title}</a></strong>
          //     </div>
          //   </div>
          // </div>
          // `;
          products_row.appendChild(template.content.cloneNode(true));
        });
      }).catch(error => {
      console.error(error);
    });
    products_el.dataset.products = '';
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.open) {
      this.header.classList.remove('bch-menu-details-opened');
    } else {
      this.header.classList.add('bch-menu-details-opened');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
